/*
 * Copyright (c) 2019. World Wide Generation Ltd
 */

import { Component, EventEmitter, Input, Output, OnInit } from '@angular/core';
import { AuthService } from 'app/shared/sdk';
import { ValueValidation, ValueList, ValueOption } from '../../lib/wwg.classes';

interface Validation {
  key: string;
  label: string;
  controlType: string;
  active: boolean;
}

@Component({
  selector: 'wwg-value-validation',
  templateUrl: './value-validation.component.html',
  styleUrls: ['./value-validation.component.scss']
})
export class ValueValidationComponent {

  public isSuperUser: boolean = false;
  public valueTypes = ['list', 'custom'];

  public validations: Validation[] = [
    {
      key: 'min',
      label: 'Min',
      controlType: 'number',
      active: false,
    },
    {
      key: 'max',
      label: 'Max',
      controlType: 'number',
      active: false,
    },
  ];

  public _model: ValueValidation;
  @Input() public valueType: string = '';
  public jsonError: boolean = false;

  @Input() get model() {
    return this._model;
  }

  @Output() modelChange = new EventEmitter();

  constructor(
    private authApi: AuthService
  ) {
  }

  ngOnInit() {
    this.authApi.isSuperUser()
      .then(isSuperUser  => {
        this.isSuperUser = !!isSuperUser;
      })
      .catch(() => undefined);
  }

  get table() {
    return JSON.stringify(this.model.table, null, 2);
  }

  set table(v) {
    try {
      this.model.table = JSON.parse(v);
      this.jsonError = false;
    } catch (e) {
      this.jsonError = true;
    };
  }

  set model(val) {
    this._model = val;
    this.modelChange.emit(this._model);
  }

  public isValueListRef() {
    return this.model && this.model.valueList && this.model.valueList.type === 'list';
  }

  public addValidation() {
    if (!this.model) {
      this.model = {};
    }
  }

  public addValueList() {
    if (!this.model.valueList) {
      this.model.valueList = { type: 'list', custom: [] };
    }
  }

  public createFn(): ValueOption {
    return { code: '', name: '' };
  }

  public isTable() {
    return this.valueType === 'table';
  }
}
